<template>
  <MainLayout>
    <div class="subscriptions-main container">
      <div class="previousBtn">
        <el-button @click="goToPreviousPage()" type="text" icon="el-icon-arrow-left" class="button my-account-btn">
          {{ $t("common.previousPageBtn.myAccount") }}
        </el-button>
      </div>
      <el-row class="d-flex align-items-center">
        <el-col class="p-20 sales-image sales-img-sec" :xs="24" :sm="12" :md="12">
          <div class="bg-accent-light text-center p-20 mt-15">
            <img :src="subscriptionsImage" class="account-image" />
          </div>
        </el-col>
        <el-col class="p-20 align-vertical" :xs="24" :sm="12" :md="12">
          <h1 class="text-left">
            {{ $t("users.account.subscriptionTitle") }}
          </h1>
        </el-col>
      </el-row>
      <el-row>
        <el-col class="p-20 package mb-20" :xs="24" :sm="24" :md="12" :offset="6">
          <label class="title">
            {{ $t("subscriptions.packages.heading") }}
          </label>
          <span class="description" v-html="$t('subscriptions.packages.description')">
          </span>
          <el-divider class="m-0 mt-60" />
        </el-col>
      </el-row>
      <el-row>
        <el-col class="p-20 infolettres mb-20 sub-mobile" :xs="24" :sm="24" :md="12" :offset="6">
          <h4 class="text-left subscription-newsletter">{{ $t("subscriptions.infolettres") }}</h4>
          <div v-for="(value, index) in infolettresList()" :key="index" class="text-left">
            <label class="title">
              <el-checkbox v-model="subscriptions[value.value]" @change="toggleSubscription(value.value)">
                {{ value.title }}
              </el-checkbox>
            </label>
            <span class="description">
              {{ value.description }}
            </span>
          </div>
        </el-col>
      </el-row>
    </div>
  </MainLayout>
</template>

<script>
import { mapState, mapActions } from "vuex";

import MainLayout from "@/components/layout/main-layout.vue";
// import LayoutSection from "@/components/layout/layout-section.vue";

export default {
  name: "subscriptions",
  components: {
    MainLayout,
  },
  data() {
    return {
      title: "Subscriptions",
      subscriptions: {},
      countryCode: "QC",
    };
  },
  mounted() {
    this.$root.$on("chancountryCode", (countryCode) => {
      this.countryCode = countryCode;
      this.infolettresList();
    });
    const infolettres = this.infolettresList();
    // const newsletterSubscribed = this.newsletterSubscribed;
    const userKey = `newsletter_${this.user.email}`;
    const newsletterPreference = JSON.parse(localStorage.getItem(userKey)) || {};
    infolettres.forEach((item) => {
      if (newsletterPreference == true) {
          this.$set(
            this.subscriptions,
            item.value,
            newsletterPreference == true
          );
      } else {
        this.$set(
          this.subscriptions,
          item.value,
          newsletterPreference[item.value] !== undefined
            ? newsletterPreference[item.value]
            : false
        );
      }
    });
  },
  computed: {
    ...mapState("subscription", []),
    ...mapState("user", ["user"]),
    subscriptionsImage() {
      /* eslint-disable global-require */
      return require("@/assets/images/account/subscriptions.png");
    },
    newsletterSubscribed() {
      return this.user.newsletter === true;
    }
  },
  methods: {
    ...mapActions("subscription", ["fetchSubscriptions"]),
    toggleSubscription(value) {
      const userKey = `newsletter_${this.user.email}`;
      let preferences = JSON.parse(localStorage.getItem(userKey));
      if (typeof preferences !== "object" || preferences === null) {
        preferences = {}; // Reset preferences to an object if invalid
      }
      preferences[value] = this.subscriptions[value];
      const infolettres = this.infolettresList();
      infolettres.forEach((item) => {
    // if (preferences[item.value] === undefined) {
      preferences[item.value] = this.subscriptions[item.value];
    // }
  });
      localStorage.setItem(userKey, JSON.stringify(preferences));
    },
    getSubscriptions() {
      this.fetchSubscriptions({});
    },
    goToPreviousPage() {
      this.$router.go(-1);
    },
    infolettresList() {
      if (this.countryCode == "ON") {
        return this.$i18n.t("subscriptions.infolettresListOn");
      }
      return this.$i18n.t("subscriptions.infolettresListQc");
    },
  },
};
</script>
<style scoped lang="scss">
.my-account-btn {
  padding-left: 0 !important;
}

.sales-image {
  padding-left: 0 !important;
}

.subscriptions-main img {
  width: 192px;
  height: 272px;
}

@import "@/assets/variables.scss";

.previousBtn {
  font-family: "Futura Std ", "Futura Std", sans-serif;
  font-weight: 500;
  color: $color-primary;
  text-align: left;
  line-height: normal;
  letter-spacing: 1.25px;
  font-size: 16px !important;

  .el-button--text {
    color: #a31c25;
    cursor: pointer;
    font-weight: 500 !important;
  }

  .el-button:hover {
    text-decoration: underline;
  }
}

@media (max-width: 320px) {
  .el-col-offset-6 {
    margin-left: 0px !important;
  }
}

.sub-mobile .el-checkbox,
.el-checkbox__input {
  white-space: break-spaces;
}

.sub-mobile {
  padding-left: 0 !important;
}

.package {
  padding-left: 0 !important;
}

.d-flex.align-items-center.el-row {
  flex-wrap: wrap;
}
</style>